import A11ySwitcherModule from '@Foundation/A11ySwitcher';
import FocusSliderModule from '@Foundation/FocusSlider';
import ScrollSliderModule from '@Foundation/ScrollSlider';
import SlideItem from '@Foundation/Slider/code/Scripts/components/slide';
import HeaderSite from '@Foundation/Header';
import ResponsiveImageModule from '@Foundation/ResponsiveImage';
import NoJsHandler from '@Foundation/NoJsHandler';
import { animate } from '@Foundation/directives/animate/animate';
import MegaMenuModule from '@Foundation/MegaMenu';
import { AnalyticsHandler, default as AnalyticsHandlerModule } from '@Foundation/analyticsHandler';
import { clickextension } from '@Foundation/directives/clickExtension/clickextension';
import { debug } from '@Foundation/env/env';
import { onselectChangeurl } from '@Foundation/directives/onSelectChangeUrl/onselect-changeurl';
import { fadein } from '@Foundation/directives/fadein/fadein';
import { srcset } from '@Foundation/directives/srcset/srcset';
import { sticky } from '@Foundation/directives/sticky/sticky';
import { backtotop } from '@Foundation/directives/backToTop/backToTop';
import { careersearch } from '@Foundation/directives/careerSearch/careerSearch';
import { catreload } from '@Foundation/directives/catReload/catReload';
import { heroanim } from '@Foundation/directives/heroAnim/heroAnim';
import { InputHandler } from '@Foundation/inputHandler';
import LoadScriptModule from '@Foundation/loadscript';
import MqHandler from '@Foundation/mqHandler/MqHandler';
import { KeySiteCore } from '@Foundation/sitecore';
import { VueModule } from '@Foundation/utilities';
import '@Foundation/wsf/wsf';
// Project
import '@Themes/index.scss';
import Vue from 'vue';
import VideoMain from '@Feature/Video/code/Scripts/VideoMain';
import VideoLazy from '@Feature/Video/code/Scripts/VideoLazy';

import BoLogin from '@Feature/NewBOPRNews/code/Scripts/BoLogin';
import BoHeader from '@Feature/NewBOPRNews/code/Scripts/BoHeader';
import BoContent from '@Feature/NewBOPRNews/code/Scripts/BoContent';
import BoPressRelease from '@Feature/NewBOPRNews/code/Scripts/BoPressRelease';
import BoNews from '@Feature/NewBOPRNews/code/Scripts/BoNews';

import './registerServiceWorker';

Vue.use(KeySiteCore);

// Configure MqHandler
MqHandler.getMqHandler({
  small: 768,
  medium: 1440
});
// Configure AnalyticsHandler
AnalyticsHandler.getAnalyticsHandler(debug);

// Configure InputHandler
InputHandler.getInputHandler();

/**
 * AMP components inside VUE
 * Configuration ignored amp-* component
 */
Vue.config.ignoredElements = [
  'amp-story',
  'amp-story-page',
  'amp-img',
  'amp-story-grid-layer',
  'amp-video',
  'amp-story-bookend'
];

Vue.config.keyCodes = {
  home: 36,
  end: 35,
};

export default VueModule({
  asyncImports: [
    {
      module: () => import(/* webpackChunkName: "single-card" */ '@Foundation/SingleCard'),
      components: [
        'SingleCard'
      ]
    },
    {
      module: () => import(/* webpackChunkName: "brand-slider" */ '@Feature/Sliders/code/Scripts/BrandSlider'),
      components: [
        'BrandSlider'
      ]
    },
    {
      module: () => import(/* webpackChunkName: "search" */ '@Feature/Search/code/Scripts'),
      components: [
        'Search',
        'SearchSuggestion'
      ]
    },
    {
      module: () => import(/* webpackChunkName: "story-slider" */ '@Feature/Sliders/code/Scripts/StorySlider'),
      components: [
        'Story'
      ]
    },
    {
      module: () => import(/* webpackChunkName: "country-selector" */ '@Foundation/CountrySelector'),
      components: [
        'CountrySelector'
      ]
    },
    {
      module: () => import(/* webpackChunkName: "modal" */ '@Foundation/Modal'),
      components: [
        'Modal'
      ]
    },
    {
      module: () => import(/* webpackChunkName: "gouvernance" */ '@Feature/Gouvernance/code/Scripts/Gouvernance'),
      components: [
        'Gouvernance'
      ]
    }
  ],
  imports: [
    // Foundation
    A11ySwitcherModule,
    AnalyticsHandlerModule,
    LoadScriptModule,
    FocusSliderModule,
    ScrollSliderModule,
    ResponsiveImageModule,
    NoJsHandler,
    SlideItem,
    HeaderSite,
    MegaMenuModule,
    VideoMain,
    VideoLazy,
    BoLogin,
    BoHeader,
    BoContent,
    BoPressRelease,
    BoNews
  ],
  directives: {
    animate,
    clickextension,
    fadein,
    srcset,
    sticky,
    catreload,
    careersearch,
    backtotop,
    onselectChangeurl,
    heroanim
  },
  filters: {}
});
